import React from "react";
import { TextButton } from "../buttons";
import { LinkItem } from "./Header";
import { Flex, Text } from "@thenounproject/lingo-core";

type Props = {
  link: LinkItem;
  variant?: "white" | "blue" | "black";
};

const LinkItemComponent = ({ link, variant = "blue" }: Props) => (
  <Flex flexDirection="column" alignItems="flex-start" gap="8px">
    <Flex justifyContent="flex-start" alignItems="center" gap="8px">
      <TextButton
        variant={variant}
        href={link.link}
        target={link.external ? "_blank" : undefined}
        rel={link.external ? "noopener noreferrer" : undefined}>
        {link.text}
      </TextButton>
    </Flex>
    {link.subtitle && <Text font="marketing.navLink">{link.subtitle}</Text>}
  </Flex>
);

export default LinkItemComponent;
